import React, {Component} from 'react';
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import {_Object, _Date} from "react-utils-y";
import {Theme} from 'theme-y';
// import {Theme} from '../../../theme/index';

import {setFormData, delFormData} from '../../actions/index'
import {dateSty} from './dateStyle';
import {formTypeDom, verifyFn} from './subpage';
import {renderBox, setLocationFn} from '../publicField';


const propTypes = {
    designationTheme: PropTypes.string,
    formType: PropTypes.string,
    inputName: PropTypes.string.isRequired,
    formText: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    hintText: PropTypes.string,
    textWidth: PropTypes.string,
    valueWidth: PropTypes.string,
    changeValue: PropTypes.func,
    errorText: PropTypes.string,
    dataType: PropTypes.string,
    // remarks  无规则 自定义传参
    // regex:PropTypes.number,//正则 input特有
    regexText: PropTypes.string,//input特有
};


let date, year, month, day, monthFirstWeek, monthDays, monthMaxDay;
let isLeap = (year) => year % 100 == 0 ? (year % 400 == 0 ? 1 : 0) : (year % 4 == 0 ? 1 : 0),//平年 瑞年
    //算个数  9-->09  12-->12
    formatTen = (num) => {
        return num > 9 ? (num + "") : ("0" + num);
    },
    //当月的上月计算
    hiddenDayUp = (year, month, i) => {
        let yearU = month == 1 ? year - 1 : year,
            monthU = month == 1 ? 12 : month - 1,
            datU = [31, 28 + isLeap(yearU), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            monthFirstWeekU = new Date(year + '/' + month + '/' + 1 + " 00:00:00").getDay(),
            dayU = datU[monthU - 1] - (monthFirstWeekU - 1 - i);
        return {
            day: dayU,
            month: monthU,
            year: yearU,
            flag: "up"
        };
    },
    //当月的下月计算
    hiddenDayNext = (year, month, dayNumN) => {
        let monthN = month == 12 ? 1 : month + 1,
            yearN = month == 12 ? year + 1 : year;
        return {
            day: dayNumN,
            month: monthN,
            year: yearN,
            flag: "next"
        };
    };

//遍历渲染的日期数据集合
const setDateData = (_date, _this) => {

    /*date*/
    let date = _date;
    year = date.getFullYear();//2018
    month = date.getMonth() + 1;//0-11   +1
    day = date.getDate();//1,2,
    monthFirstWeek = new Date(`${year}/${month}/1`).getDay();//获取这个月分第一天是星期几。 0-6 0是星期日
    monthMaxDay = new Date(year, month, 0).getDate();

    let iNum = (monthMaxDay + monthFirstWeek < 36) ? 35 : 42;
    let listDomDays = iNum == 35 ? [[], [], [], [], []] : [[], [], [], [], [], []],
        thisDay = 0,
        nextDay = 0,
        rows = 0;
    for (let i = 0; i < iNum; i++) {
        rows = parseInt(i / 7);
        //renderType  日期渲染重 星期日开始 还是星期一开始
        let flag = _this.props.renderType == "ch" ? (i + 1) : i;
        if (flag < monthFirstWeek) {//上月
            listDomDays[rows].push(hiddenDayUp(year, month, i));
            continue
        }
        if (flag >= monthFirstWeek && thisDay < monthMaxDay) {//这个月
            listDomDays[rows].push({
                day: thisDay + 1,
                month: month,
                year: year,
                flag: "now"
            });
            thisDay++;
            continue
        }
        if (flag > parseInt(monthMaxDay + monthFirstWeek) - 1) {//下个月
            if (monthMaxDay + monthFirstWeek > 35) {
                nextDay++;
                listDomDays[rows].push(hiddenDayNext(year, month, nextDay));
            } else {
                if (i + 1 > 35) {
                    listDomDays[rows].push(0)
                } else {
                    nextDay++;
                    listDomDays[rows].push(hiddenDayNext(year, month, nextDay));
                }
            }
            continue
        }
    }

    if (_this.props.schedule == "1" || _this.props.schedule == "2") {
        let beginDate = listDomDays[0][0].year + "-" + formatTen(listDomDays[0][0].month) + "-" + formatTen(listDomDays[0][0].day);
        let endDate = listDomDays[listDomDays.length - 1][6].year + "-" + formatTen(listDomDays[listDomDays.length - 1][6].month) + "-" + formatTen(listDomDays[listDomDays.length - 1][6].day);
        // _this.setState({
        //     loading: true
        // });
        // _this.getScheduleListFn(beginDate, endDate);
        _this.props.getScheduleFn && _this.props.getScheduleFn(beginDate, endDate);
    }
    return {
        year,
        month,
        day,
        listDomDays
    }
};

class DateField extends Theme {
    constructor(props) {
        super(props);
        let _state = {
            focusState: false,//处理点击的样式
            initFocusState: 0,//是否触发过 0 未触发  1 已经触发
            errorState: false,//是否显示报错提示框，  true  显示报错  false  不显示

            dateOpen: false,//是否显示日期弹出框

            shouldUpdate: true,//选择年份或者月份滚动分页状态
            showYear: false,//显示年份下拉
            chooseYear: new Date().getFullYear(),//显示选择的年份值
            showMonth: false,//显示月份下拉
            chooseMonth: new Date().getMonth(),//显示选择的月份值

            date: new Date(),//当前日期

            dayActive: _Date.format(new Date(), "yyyy-MM-dd").replace(/-/g, "/"),//默认选中今天

            // loading: false,
            // scheduleData: [],
            renderDateData: {year: 0, month: 0, day: 0, listDomDays: []},

            selLocationH: "bottom",// selLocation:"bottom"  // top  bottom
            selLocationW: "right",// left   right
        };
        this.state = _Object.merge(this.state || {}, _state)
    };

    //年份的下拉滚动条
    initScroll = () => {
        this.setState({shouldUpdate: false});
    };
    //请求日期排班
    getScheduleListFn = (beginDate, endDate)=> {

        // this.props.getScheduleFn && this.props.getScheduleFn(beginDate, endDate);
        // let _this = this;
        // this.props.getScheduleList(this.props.userId, beginDate, endDate, function (res) {
        //     _this.setState({
        //         scheduleData: res.errorCode == "0" ? res.data : [],
        //         loading: false
        //     })
        // })
    };
    //选择年份 月份
    handleHead = (type) => {
        if (type == "year") {
            this.setState({
                showMonth: false,
                showYear: true
            })
        } else {
            this.setState({
                showMonth: true,
                showYear: false
            })
        }
    };
    //移动年份 月份
    moveYear = (value, type) => {
        if (type == "year") {
            this.setState({chooseYear: value})
        } else {
            this.setState({chooseMonth: value})
        }
    };
    //选择年份 月份
    handleYear = (value, type) => {
        if (type == "year") {
            this.setState({
                showYear: false,
                showMonth: false,
                date: new Date(value + "/01/01"),
                renderDateData: setDateData(new Date(value + "/01/01"), this),
                handleDay: `1月1日`
            })
        } else {
            this.setState({
                showYear: false,
                showMonth: false,
                date: new Date(this.state.date.getFullYear() + "/" + formatTen(value) + "/01"),
                renderDateData: setDateData(new Date(this.state.date.getFullYear() + "/" + formatTen(value) + "/01"), this),
                handleDay: `${value}月1日`
            })
        }
    };
    //点旁边关闭下拉
    colseSelest = (year) => {
        this.setState({
            showYear: false,
            showMonth: false
        })
    };
    /*显示日历控件*/
    showDate = (e) => {
        let _this = this;

        if (this.props.disabled)return;

        this.setState({dateOpen: true});

        let formDataValue = _this.props.formData[_this.props.dataType || "default"];
        let inputData = formDataValue && formDataValue[_this.props.inputName];

        let minDate = _this.props.minDate,
            maxDate = _this.props.maxDate,
            minDateTimes,
            maxDateTimes,
            dateValue = inputData && inputData.text ? inputData.text : "";//_this.props.dataObj[_this.props.inputName];

        if (minDate) {
            minDateTimes = new Date(_this.props.minDate.replace(/-/g, "/")).getTime();
        }

        if (maxDate) {
            maxDateTimes = new Date(_this.props.maxDate.replace(/-/g, "/")).getTime();
        }

        if (dateValue) {
            if (minDateTimes > new Date(dateValue).getTime() || new Date(dateValue).getTime() > maxDateTimes) {
                _this.setState({
                    dayActive: dateValue.replace(/-/g, "/")
                })
            }
        } else {
            if (minDateTimes > new Date().getTime() || new Date().getTime() > maxDateTimes) {
                _this.setState({
                    dayActive: ""
                })
            }
        }

        _this.setState({
            handleDay: dateValue ? `${dateValue.split("-")[1]}月${dateValue.split("-")[2]}日` : "",
            renderDateData: setDateData(dateValue ? new Date(dateValue) : _this.props.setDate ? new Date(_this.props.setDate) : new Date(), _this)
        });

        setLocationFn(_this, e);

        // let dateP = dateValue.split("-");
        // let year = dateP[0];
        // let month = dateP[1];
        // let day = dateP[2];
        // this.setState({
        //     date: new Date(year + '/' + month + '/' + day),
        //     scheduleData: [],
        //     renderDateData: setDateData(new Date(year + '/' + month + '/' + day), this)
        // });
    };
    //上个月点击
    lastMonth = (year, month) => {
        let yearL = month == 1 ? year - 1 : year,
            monthL = month == 1 ? 12 : month - 1;
        this.setState({
            date: new Date(yearL + '/' + monthL + '/' + 1),
            // scheduleData: [],
            renderDateData: setDateData(new Date(yearL + '/' + monthL + '/' + 1), this)
        });
    };
    //下个月点击
    nextMonth = (year, month) => {
        let yearN = month == 12 ? year + 1 : year,
            monthN = month == 12 ? 1 : month + 1;
        this.setState({
            date: new Date(yearN + '/' + monthN + '/' + 1),
            // scheduleData: [],
            renderDateData: setDateData(new Date(yearN + '/' + monthN + '/' + 1), this)
        });
    };
    //移动日期
    handleDayMoveFn = (value, flag) => {
        if (flag == "disabled") {
            return false
        }
        this.setState({
            dayMoveOn: `${value.year}/${formatTen(value.month)}/${formatTen(value.day)}`
        })
    };
    //选中日期
    handleDayActiveFn = (value, flag) => {
        if (flag == "disabled") {
            return false
        }
        this.setState({
            dayActive: `${value.year}/${formatTen(value.month)}/${formatTen(value.day)}`,
            handleDay: `${value.month}月${formatTen(value.day)}日`
        })
    };
    //下拉点击旁边关闭下拉  设置date值
    handleDayCloseSelect = () => {
        this.setState({dateOpen: false, initFocusState: 1});
        if (this.state.dayActive) {
            this.setState({
                dateOpen: false
            });
            let value = this.state.dayActive.replace(/\//g, "-");
            let obj = [{
                type: "date",//type 类型
                name: this.props.inputName,//name input名称
                text: value,//text input值
                value: value,
                obj: {},
                remarks: this.props.remarks,//备注
                other: {
                    required: this.props.required
                }
            }];
            this.props.setFormData(obj, this.props.dataType);
            this.props.changeValue && this.props.changeValue(obj[0]);
        }
    };
    //数据提交
    handleDaySubmit = () => {
        if (this.state.dayActive) {
            this.setState({
                dateOpen: false
            });
            let value = this.state.dayActive.replace(/\//g, "-");
            let obj = [{
                type: "date",//type 类型
                name: this.props.inputName,//name input名称
                text: value,//text input值
                value: value,
                obj: {},
                remarks: this.props.remarks,//备注
                other: {
                    required: this.props.required
                }
            }];
            this.props.setFormData(obj, this.props.dataType);
            this.props.changeValue && this.props.changeValue(obj[0]);
        }
    };
    //返回 关闭弹出框
    handleDayCloseDialog = () => {
        this.setState({dateOpen: false, initFocusState: 1});
    };

    componentWillMount() {
        let props = this.props;
        let flag = "set";
        try {
            //已经存在数据 就不 重新赋值
            flag = props.formData[props.dataType || "default"][props.inputName] ? "none" : "set"
        } catch (ex) {
            flag = "set"
        } finally {
            if (props.inputName && flag == "set") {
                let obj = [{
                    type: "date",//type 类型
                    name: this.props.inputName,//name input名称
                    text: "",//text input值
                    value: "",
                    obj: {},
                    remarks: this.props.remarks,//备注
                    other: {
                        required: this.props.required
                    }
                }];
                props.setFormData(obj, props.dataType);
            }
        }

    }

    componentDidMount() {

    }
    componentWillUnmount() {
        this.props.delFormData(this.props.inputName || "", this.props.dataType)
    }
    render() {
        return renderBox(this, dateSty, formTypeDom, verifyFn)
    }
}

DateField.propTypes = propTypes;

const mapStateToProps = state => {
    return {
        formData: state.formData,
        subVerifyRes: state.subVerifyRes,
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({
    setFormData: (data, dataType) => dispatch(setFormData(data, dataType)),
    delFormData: (inputName, dataType) => dispatch(delFormData(inputName, dataType))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DateField)

